import { render, staticRenderFns } from "./EcommerceProfitChart.vue?vue&type=template&id=79b0911e&"
import script from "./EcommerceProfitChart.vue?vue&type=script&lang=js&"
export * from "./EcommerceProfitChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b0911e')) {
      api.createRecord('79b0911e', component.options)
    } else {
      api.reload('79b0911e', component.options)
    }
    module.hot.accept("./EcommerceProfitChart.vue?vue&type=template&id=79b0911e&", function () {
      api.rerender('79b0911e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ecommerce/EcommerceProfitChart.vue"
export default component.exports